'use strict';

var fragmentMasking = require('./src/fragment-masking.js');
var gql = require('./src/gql.js');



exports.getFragmentData = fragmentMasking.getFragmentData;
exports.isFragmentReady = fragmentMasking.isFragmentReady;
exports.makeFragmentData = fragmentMasking.makeFragmentData;
exports.gql = gql.gql;
